import React from 'react';
import { Link } from 'react-router-dom';
import routes from 'src/routes';
import Page from 'src/components/Page';
import SpecLink from 'src/components/SpecLink';

function TokenTwoPartyPage() {
    return <Page header="2-party AuthKey">
        <p>
            2-party AuthKey token processing involves the merchant passing payment details (including card or account numbers) directly to BPOINT.
            This involves the merchant first <SpecLink uriFragment="#operation/TokenAuthkey_CreateAuthkey">obtaining an AuthKey</SpecLink> from BPOINT which can then be used for subsequent operations.
        </p>
        <p>
            To create a token you must, at minimum, perform the following:
        </p>
        <ol>
            <li><SpecLink uriFragment="#operation/TokenAuthkey_CreateAuthkey">Create authkey</SpecLink></li>
            <li><SpecLink uriFragment="#operation/TokenAuthkey_AttachTokenDetails">Attach token details</SpecLink></li>
            <li><SpecLink uriFragment="#operation/TokenAuthkey_AttachPaymentMethod">Attach payment method (card or bank account account details)</SpecLink></li>
            <li><SpecLink uriFragment="#operation/TokenAuthkey_Process">Process token</SpecLink></li>
        </ol>
        <p>
            Refer to <Link exact to={routes.api.token.authkey.flow}>2-party token flow</Link> to compare the difference between AuthKey and non-AuthKey flows.
        </p>
       
    </Page>
}

export default TokenTwoPartyPage;
